import React from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd';
import {AdmsRepository} from '../../redux/AdmsActions';

const Loading = () => <div className="filter_abc_div abc_div active"> Загрузка алфавита <Spin size="small" /></div>;

/** Одна буква  */
const Letter = ({value, count}) => {
    const label = (count)?count:value;
    return (
        <span>({label})</span>
    )
}

/** Список букв */
const Letters = ({letters, selected, onChangeLetter, chars}) => {
  return (
    <div className="filter_abc_div abc_div active">
      {letters.map((letter, i) => {
          if (typeof chars[letter] === 'undefined') 
            return <a key={i} href="javascript:" style={{pointerEvents: "none", cursor: "default", color:"#DCDCDC"}}>{letter}</a>;
          const isChecked = (selected)? selected.filter(item => item.letter==letter).length>0: false;
          return <a key={i} href="javascript:" onClick={()=> onChangeLetter(isChecked, letter)} className={(isChecked)?"active":null}>{letter}</a>
        }
      )}
    </div>            
  )
}

/** Алфавитный список */
class Alphabet extends React.Component {
  
    constructor(props, context) {
        super(props, context)
        this.state = {
            loaded: false,      //Флаг загрузки
            cyrillic: [...'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧЧШЩЭЮЯ'],
            latin: [...'ABCDEFGHIKLMNOPQRSTVXYZ'],
        }
    }
    
  componentDidMount() {
    this.makeLetters();
  }

  componentDidUpdate(prevProps, prevState) {
    this.makeLetters();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.chars==null) {
      return {
        loaded: false,
        cyrillic: state.cyrillic
      };
    }
    return null; // Return null to indicate no change to state.
  }

  makeLetters () {
    if (this.state.loaded) return;
    const cyrillic = [...'АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧЧШЩЭЮЯ'];
    const latin = [...'ABCDEFGHIKLMNOPQRSTVXYZ'];
    const {vset, lang, graph, rfilter, conditions} = this.props;
    this.props.dispatch(AdmsRepository.loadFirstCharCount(lang, graph, rfilter, conditions))
      .then ((response) =>{
          //console.log("Done!", response);
          this.setState({loaded: true, cyrillic, latin});
      })
      .catch(e => { 
          console.error("Error!", e);
      });
    }

    onChangeLetter(active, letter) {
        console.log(`active = ${active} letter = ${letter}`);
        const {onChange} = this.props;
        if (onChange){
            if (!active) return onChange(true, letter);
            const {selected } = this.props;
            const item = selected.filter(item => item.letter==letter)[0];
            onChange(false, item);
        }
    }

    render() {
        //console.log(this);
        const {loaded, cyrillic, latin } = this.state
        const {selected, chars } = this.props;
        return (
            (!loaded? 
              <div>
                <Loading />
                <Loading />
              </div>
            : 
              <div>
              <Letters selected={selected} letters={cyrillic} onChangeLetter={(c, l)=>this.onChangeLetter(c, l)} chars={chars} />
              <Letters selected={selected} letters={latin} onChangeLetter={(c, l)=>this.onChangeLetter(c, l)} chars={chars} />
              </div>
            )
        )
    }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vadms, vset} = state;
    //Параметры, которые могут прийти из настроек
    const IRI = "http://www.w3.org/2000/01/rdf-schema#label";
    const {graph, lang } = props;
    const rGraph = (graph)? graph: vset.graph;
    const statistic = (vadms && vadms.statistics)?vadms.statistics[IRI]:{};
    const chars = ((typeof statistic === 'undefined') || (typeof statistic["chars"] === 'undefined'))? null: statistic["chars"];
    return {
        graph: rGraph,
        lang: (lang)?lang: vset.lang,
        IRI,
        rfilter: vadms.rfilter,
        conditions: vadms.conditions,
        chars,
        vset
    };
}
export default connect(mapStateToProps)(Alphabet);
//export default Alphabet;